import { createSelector } from "reselect";
import { StoreState } from "../../../models/states/StoreState";

export const selectNavigationMessage = createSelector(
    [
        (state: StoreState) => state.isPageMessagesEnabled,
        (state: StoreState) => state.interview.navigation?.message,
    ],
    (isPageMessagesEnabled, message) => (isPageMessagesEnabled ? message : undefined),
);

export const selectNavigationDisabled = createSelector(
    [(state: StoreState) => state.interview.navigation?.disabled, selectNavigationMessage],
    (disabled, message) => disabled || (message != null && message !== ""),
);
